import { DoorFrontTwoTone } from "@mui/icons-material";
import { CSSProperties } from "react";

export default function DoorIcon({ style }: { style?: CSSProperties }) {
  return (
    <DoorFrontTwoTone style={{ color: "#363636", fontSize: '40px', ...style }} />
  )
}